import { cx } from '../../cx'
import styles from './ProgressBar.module.css'

export interface ProgressBarProps {
  /** Bieżący krok, liczony od 1. */
  value: number
  max: number
  /** Etykieta dla czytników ekranu — pasek sam w sobie nic nie mówi. */
  label: string
  className?: string
}

/** Pasek postępu wizarda (spec 04): niski tor, wypełnienie brandowe, animacja szerokości. */
export function ProgressBar({ value, max, label, className }: ProgressBarProps) {
  const safeMax = Math.max(1, max)
  const clamped = Math.min(safeMax, Math.max(0, value))
  const percent = Math.round((clamped / safeMax) * 100)
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={safeMax}
      aria-valuenow={clamped}
      aria-label={label}
      className={cx(styles.track, className)}
    >
      <span className={styles.fill} style={{ width: `${percent}%` }} />
    </div>
  )
}
